class Product{constructor(){this.acc=[],this.container=document.querySelector(".m-main-product"),MinimogTheme.CompareProduct&&MinimogTheme.CompareProduct.setCompareButtonsState(),MinimogTheme.Wishlist&&MinimogTheme.Wishlist.setWishlistButtonsState(),this.addRecentViewedProduct(),addEventDelegate({context:this.container,selector:(window.__minimog_review_selector||"")+".m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview",handler:e=>{const t=e.target.closest(".m-product-collapsible").dataset.index;setTimeout((()=>{this.acc[Number(t)].setContentHeight()}),300)},capture:!0})}addRecentViewedProduct(){const e=getCookie("m-recent-viewed-products");let t=e?JSON.parse(e):[];-1===t.indexOf(MinimogSettings.productHandle)&&(t.unshift(MinimogSettings.productHandle),t=t.slice(0,20),setCookie("m-recent-viewed-products",JSON.stringify(t)))}}

/* TRB aggregateRating injection - reads Trustoo vstar_product_rating and injects into ProductGroup schema */
(function(){
  try {
    if (typeof vstar_product_rating === 'undefined' || !vstar_product_rating ||
        !vstar_product_rating.rating || !vstar_product_rating.total_reviews) return;
    var ratingVal = parseFloat(vstar_product_rating.rating);
    var reviewCount = parseInt(vstar_product_rating.total_reviews, 10);
    if (!ratingVal || !reviewCount || reviewCount < 1) return;

    var blocks = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < blocks.length; i++) {
      var s = blocks[i].textContent || '';
      if (s.indexOf('ProductGroup') > -1 && s.indexOf('aggregateRating') === -1) {
        try {
          var obj = JSON.parse(s);
          obj.aggregateRating = {
            "@type": "AggregateRating",
            "ratingValue": ratingVal,
            "reviewCount": reviewCount,
            "bestRating": "5",
            "worstRating": "1"
          };
          blocks[i].textContent = JSON.stringify(obj, null, 2);
        } catch(e) {}
      }
    }
  } catch(e) {}
})();
